import type { PilotPercent } from '../types';
import { api } from './http';

export const getStatsByPeriod = (year?: number | null, month?: number | null) => {
  const params: Record<string, number> = {};
  if (year != null) params.year = year;
  if (month != null) params.month = month;
  return api.get<{
    total_hours: number;
    flights_count: number;
    landings: number;
    pilots: PilotPercent[];
  }>('/stats/by-period', { params });
};
export const getStatsYears = () =>
  api.get<{ years: number[] }>('/stats/years');
